<div class="container">
     <p-fieldset legend="On Duty" >
          <div class="text-sm">
               The total scheduled or actual time from sign-in (Duty Start) thru debrief (Duty End) for this duty period.
               <ul>
                    <li>
                         Debrief ends 15 minutes after block in for domestic sequences and 30
                         minutes after block in for international sequences.
                    </li>
               </ul>
             </div>
     </p-fieldset>
     <p-fieldset legend="FDP">
          <div class="text-sm">
               <div>Flight Duty Period (FAA Part 117).</div>
               <ul>
                 <li>Starts at sign-in and ends at block-in of last flight.</li>
                 <li>Does not include debrief.</li>
                 <li>Does not include deadhead if the deadhead is the last or only leg.</li>
               </ul>
               <a href="https://www.alliedpilots.org/-/media/AlliedPilots/Member/Committee/FTDT/GEN/Docs/FAR-117-Guidance/FAR117-Quick-Reference-Guide_24SEPT2018.pdf"
                 target="_blank" class="link">
                 <i class="pi pi-external-link"></i>
                 FAR 117 Quick Reference
          </a>
          </div>
     </p-fieldset>
     <p-fieldset legend="Layover">
          <div class="text-sm">
               <ul>
                    <li>Layover details the station in which the layover occured beginning at the end of the duty day.</li>
                    <li>ODL defines the actual layover length in hours and minutes.</li>
               </ul>
          </div>
     </p-fieldset>
</div>

